module.exports = __webpack_public_path__ + "static/media/smoking.800566e5.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/lsc/smoking.svg
// module id = 443
// module chunks = 0